/**
 * application.js
 *
 * This file compiles to /public/assets/js/application.js
 * You should use it to import all your js components
 */

window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');

require('bootstrap');

import moment from 'moment';

window.Vue = require('vue');

Vue.component('layout', require('../layouts/App.vue'));

Object.defineProperty(Vue.prototype, '$moment', {
	value: moment
});

const app = new Vue({
    el: '#app'
});

require('./scripts');


// WEBPACK FOOTER //
// ./src/js/application.js